import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar,MatDialog } from '@angular/material';
import { AppService } from '../commons/app.service';
import { TranslateService } from '@ngx-translate/core';
import {AppBaseComponent} from '../commons/AppBaseComponent';
import { FourDService } from '4d-mapper';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';
import { TicketRequest } from '../commons/models';

@Component({
    selector: 'contact-comp',
    templateUrl: './contact.component.html'
})
export class ContactComponent extends AppBaseComponent{

    
    contactUsRequest:TicketRequest

    constructor(public fourD: FourDService, public service: AppService, public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, 
        public translate: TranslateService, applicationEvents:XsApplicationEventsService) {
        super(service, router, snackBar, dialog, applicationEvents);
    } 

    onReady() {
        this.resetTicket()
    } 
    
    resetTicket() {
        this.contactUsRequest = {
            subject:'',
            priority:'normal',
            category:'question',
            body:''
        }
    }
    
    send() {
        
        this.service.sendSupportTicket(this.contactUsRequest).subscribe(
            res => {
                this.resetTicket()
                this.openSnackBarSuccess("MAP.GUIDES_DASHBOARD.CONTACT_US.SENT")
            }, err => {
                this.openSnackBarError('MAP.GUIDES_DASHBOARD.CONTACT_US.SENT_ERROR')
            }
        )
       
    }    
}